export default __webpack_public_path__ + "static/media/blue-plus.3e06d17c.svg";